import { AxiosInstance } from "axios"

export interface TagValue {
  id: number
  name: string
  order: number
}

export interface TagGroup {
  id: number
  name: string
  owner: number
  owner_username: string
  values: TagValue[]
  created_at: string
  updated_at: string
}

/** Map of instrument_id -> { tag_group_id: tag_value_name } */
export type TagAssignmentMap = Record<string, Record<string, string>>

export interface ITagsApi {
  getGroups: () => Promise<TagGroup[]>
  getAssignmentsByInstrument: () => Promise<TagAssignmentMap>
}

const tagsApi = (axiosClient: AxiosInstance): ITagsApi => ({
  getGroups: async () => {
    const { data } = await axiosClient.get<TagGroup[]>("/trading/tags/groups/")
    return data
  },
  getAssignmentsByInstrument: async () => {
    const { data } = await axiosClient.get<TagAssignmentMap>(
      "/trading/tags/assignments/instruments/"
    )
    return data
  },
})

export default tagsApi
